import React from "react";
import "./styles.scss";
import OrdersIcon from "../../Icons/OrdersIcon";
import { useNavigate } from "react-router-dom";

const BottomTab = () => {
  const navigate = useNavigate();

  return (
    <div className="bottom-tab-container">
      {/* <div className="tab-item"></div>
      <div className="tab-item"></div>
      <div className="tab-item"></div> */}
      <div
        className="tab-item center-item adb-touchable"
        onClick={() => navigate("/order")}
      >
        <OrdersIcon />
      </div>
      {/* <div className="tab-item"></div>
      <div className="tab-item"></div> */}
    </div>
  );
};

export default BottomTab;
